module.exports = __webpack_public_path__ + "img/jp-yen.fda08524.svg";